export default "__VITE_ASSET__B99F9reU__"